<template>
  <el-dialog class="homeLogin" title="登录" :visible.sync="visible" :show-close="false" :width="loginWidth" :modal="true" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="dialog-login">
      <div class="dialog-con">
        <el-form ref="form" :model="form" :class="{ 'm-el-form': isDesMobile }" :label-position="isDesMobile ? 'top' : 'left'" :label-width="isDesMobile ? 0 : '100px'">
          <div>
            <div>
              <template v-if="lang == 'zh'">
                <el-form-item :label="$t('lang.手机号')" required>
                  <el-input type="text" :placeholder="$t('lang.手机号')" v-model="form.mobile"></el-input>
                </el-form-item>
              </template>
              <template v-if="lang == 'en'">
                <el-form-item :label="$t('lang.邮箱')" required>
                  <el-input type="text" :placeholder="$t('lang.邮箱')" v-model="form.email"></el-input>
                </el-form-item>
              </template>
            </div>
          </div>

          <el-form-item :label="$t('lang.原密码')" required>
            <el-input type="password" :placeholder="$t('lang.原密码')" v-model="form.oldPassword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.新密码')" required>
            <el-input type="password" :placeholder="$t('lang.新密码')" v-model="form.newPassword"></el-input>
          </el-form-item>
          <el-form-item :label="$t('lang.确认密码')" required>
            <el-input type="password" :placeholder="$t('lang.确认密码')" v-model="form.confirmPassword"></el-input>
          </el-form-item>
          <!--修改密码 是否需要验证码？有的模板不需要-->
          <template>
            <div>
              <template v-if="lang == 'zh'">
                <el-form-item :label="$t('lang.验证码')" required>
                  <el-input class="mobileCode" v-model="form.code" type="text" :placeholder="$t('lang.请输入手机验证码')" />
                  <el-button v-if="phoned" class="queryCode" :loading="loadingMobileCode" @click="queryPhoneCode()" type="primary">{{$t('lang.验证码')}}
                  </el-button>
                  <el-button v-if="!phoned" class="queryCode">{{ timer }}s</el-button>
                </el-form-item>
              </template>
              <template v-if="lang == 'en'">
                <el-form-item :label="$t('lang.验证码')" required>
                  <el-input class="emailCode" v-model="form.code" type="text" :placeholder="$t('lang.请输入邮箱验证码')" />
                  <el-button v-if="phoned" :loading="loadingMobileCode" class="queryCode" @click="queryPhoneCode()" type="primary">{{$t('lang.验证码')}}
                  </el-button>
                  <el-button v-if="!phoned" class="queryCode">{{ timer }}s</el-button>
                </el-form-item>
              </template>
            </div>
          </template>

        </el-form>
      </div>
      <div class="admin-btn">
        <el-button class="buttonSave" @click="cancel()">{{$t('lang.取消')}}</el-button>
        <el-button class="buttonSave" @click="save()" type="primary">{{$t('lang.确定')}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import { getPassword } from "@common/api";
import { isMobile, isEmail } from "@common/utils";
import { getLoginUser } from "@common/utils";
import myalert from "@common/utils/myalert";
import { isNil } from "@common/utils";
import messageStoreMixin from "@match/store/message/messageStoreMixin";
import { setCookie } from "@common/utils";
import { mapGetters } from "vuex";
import { sendCode } from "@common/api";
import { MODE } from "../../config";

export default {
  props: {
    visible: true,
    userId: { type: [String, null,] },
    projectId: { type: [String, null,] }
  },
  mixins: [messageStoreMixin],
  data() {
    return {
      MODE,
      form: {
        mobile: '',
        email: '',
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
        code: ''
      },
      lang: sessionStorage.getItem("lang") || 'zh',
      loginWidth: '450px',
      phoned: true,
      timer: 60,
      loadingMobileCode: false,
      loginCode: '',
      userType:0
    };
  },
  computed: {
    ...mapGetters("mobile", ["isDesMobile"])
  },
  mounted() {
    this.lang = sessionStorage.getItem("lang") || 'zh';
    this.loginWidth = this.isDesMobile ? '90%' : '450px'
    this.userType = sessionStorage.getItem('userType')
  },
  methods: {
    // 获取验证码
    queryPhoneCode() {
      if (this.lang == 'zh') {
        if (isNil(this.form.mobile)) {
          myalert.fail("手机号不能为空")
          return false
        } else {
          let vals = isMobile(this.form.mobile)
          if (!vals) {
            this.$message({
              message: '请输入正确的手机号！',
              type: 'error'
            })
            return false
          }
        }
      } else {
        if (isNil(this.form.email)) {
          myalert.fail("邮箱不能为空")
          return false
        } else {
          let vals = isEmail(this.form.email)
          if (!vals) {
            this.$message({
              message: '请输入正确的邮箱！',
              type: 'error'
            })
            return false
          }
        }
      }
      if (this.lang == 'zh') {
        var params = {
          phone: this.form.mobile,
        }
        console.log(111, params)
      } else {
        var params = {
          email: this.form.email,
        }
      }
      console.log(this.lang)
      this.loadingMobileCode = true
      sendCode(params).then(res => {
        this.loadingMobileCode = false
        if (res.code == 0) {
          //this.loginCode=res.code
          this.handleClick()
        } else {
          this.$message({
            message: res.msg,
            type: 'error'
          })
        }
      }).catch(e => {
        this.loadingMobileCode = false
      })
    },
    //保存
    save() {
      var user = getLoginUser()
      console.log(user)
      var self = this
      //验证码 有些模板不需要
      console.log("MODE -",MODE)

        if (this.lang == 'zh') {
          if (isNil(this.form.mobile)) {
            myalert.fail("手机号不能为空")
            return false
          } else {
            let vals = isMobile(this.form.mobile)
            if (!vals) {
              this.$message({
                message: '请输入正确的手机号！',
                type: 'error'
              })
              return false
            }
          }
        } else {
          if (isNil(this.form.email)) {
            myalert.fail("邮箱不能为空")
            return false
          } else {
            let vals = isEmail(this.form.email)
            if (!vals) {
              this.$message({
                message: '请输入正确的邮箱！',
                type: 'error'
              })
              return false
            }
          }
        }
        if (isNil(this.form.code)) {
          myalert.fail("验证码不能为空")
          return false
        }
      

      if (isNil(this.form.oldPassword)) {
        myalert.fail("原密码不能为空")
        return false
      }
      if (isNil(this.form.newPassword)) {
        myalert.fail("新密码不能为空")
        return false
      }
      if (isNil(this.form.confirmPassword)) {
        myalert.fail("确认密码不能为空")
        return false
      }
      if (this.form.confirmPassword != this.form.newPassword) {
        myalert.fail("请确认新密码与确认密码是否一致")
        return false
      }

      let params = {
        confirmPassword: this.form.confirmPassword,
        id: this.userId || user.id,
        newPassword: this.form.newPassword,
        oldPassword: this.form.oldPassword,
        projectId: this.projectId || user.projectId,
        src:  this.userType,
        code: this.form.code
      }
      getPassword(params).then(res => {
        if (res.code == 0) {
          myalert.success("修改密码成功")
          this.$emit('update:visible', false);
          setCookie("user2", "")
          //如果是后台系统用这个组件 不刷新界面
          if (!this.userId) {
            setTimeout(() => {
              location.href = `/font/toLogin?projectId=${user.projectId}`
            }, 1000)
            return false
          }
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      })
    },
    //60s倒计时
    handleClick() {
      this.phoned = !this.phoned      //点击button改变v-show的状态
      let auth_timer = setInterval(() => {  //定时器设置每秒递减
        this.timer--;        //递减时间
        if (this.timer <= 0) {
          this.phoned = !this.phoned    //60s时间结束还原v-show状态并清除定时器
          clearInterval(auth_timer)
          this.timer = 60
        }
      }, 1000)
    },
    //取消
    cancel() {
      console.log(333)
      this.$emit('update:visible', false);
    },
  }
};
</script>
<style scoped>
.dialog-login {
  padding: 30px 30px 30px;
}

.dialog-con {
  margin-top: 15px;
}

.dialog-login .admin-btn {
  width: 100%;
  text-align: center;
  margin: 5px auto;
}

.dialog-login .buttonSave {
  width: 40% !important;
  height: 40px;
  font-size: 14px;
}

.mobileCode {
  width: 53% !important;
  margin-right: 1%;
}

.emailCode {
  width: 38% !important;
  margin-right: 1%;
}
</style>



// WEBPACK FOOTER //
// src/match/components/password/password.vue